export default __webpack_public_path__ + "static/media/github.feb228f9.svg";